import { useState } from "react";
import {
  Layout,
  Button,
  Dropdown,
  Avatar,
  Space,
  Typography,
  Image,
  Grid,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import logoApp from "../../../assets/images/logo_metromedellin.jpg";

import { METRO_COLORS } from "../../../constants/colors";
import useAuth from "../../../hooks/useAuth";
import ModalEditarUsuario from "../../modales/Perfil/components/ModalEditarUsuario";

const { Header: AntHeader } = Layout;
const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

export default function AppHeader({ logoutLocalFuntion }) {
  const { session, refreshUserInfo } = useAuth();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [showEditProfile, setShowEditProfile] = useState(false);

  const userMenuItems = [
    {
      key: "profile",
      icon: <SettingOutlined />,
      label: "Gestión de Perfil",
      onClick: () => setShowEditProfile(true),
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Cerrar Sesión",
      onClick: logoutLocalFuntion,
    },
  ];

  return (
    <AntHeader
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
        borderBottom: "1px solid #e9ecef",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: isMobile ? "0 12px" : "0 32px",
        height: 72,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        position: "relative",
        zIndex: 1000,
      }}
    >
      {/* Logo y Título */}
      <Space align="center" size={isMobile ? "small" : "large"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: isMobile ? "6px 10px" : "8px 16px",
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "12px",
            border: "1px solid #e9ecef",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <Image
            src={logoApp}
            preview={false}
            alt="Logo Metro de Medellín"
            width={isMobile ? 100 : 180}
            style={{
              borderRadius: "6px",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
            }}
          />
        </div>
        {!isMobile && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Title
              level={3}
              style={{
                margin: 0,
                color: METRO_COLORS.black,
                whiteSpace: "nowrap",
                fontSize: "24px",
                fontWeight: "700",
                textShadow: "0 1px 2px rgba(0,0,0,0.05)",
              }}
            >
              Plataforma de Gestión CISE
            </Title>
            <Text
              style={{
                fontSize: "12px",
                color: "#666",
                marginTop: "-4px",
                fontStyle: "italic",
              }}
            >
              Centro de Información de Seguridad y Emergencias
            </Text>
          </div>
        )}
      </Space>

      {/* Usuario y Dropdown */}
      <Space size="middle" align="center">
        {!isMobile && (
          <div style={{ textAlign: "right", lineHeight: "1.2" }}>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: METRO_COLORS.black,
                marginBottom: "2px",
              }}
            >
              {session?.user?.email || "Usuario"}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                textTransform: "capitalize",
              }}
            >
              {session?.user?.role || "Sin rol asignado"}
            </div>
          </div>
        )}
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" arrow>
          <Button
            type="text"
            style={{
              padding: "4px 8px",
              borderRadius: "8px",
              border: "1px solid #f0f0f0",
              background: "white",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            }}
          >
            <Avatar
              size={32}
              src={session?.user?.photoDisplayUrl}
              icon={<UserOutlined />}
              style={{
                backgroundColor: METRO_COLORS.primary,
                border: "2px solid white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            />
          </Button>
        </Dropdown>
      </Space>

      <ModalEditarUsuario
        open={showEditProfile}
        setOpen={setShowEditProfile}
        item={session?.user}
        fetchData={refreshUserInfo}
      />
    </AntHeader>
  );
}
